import posthog from 'posthog-js'
import { env } from '@/lib/env'
import { annotateClientExceptionEvent } from '@/lib/observability/exception-filter'
import { sanitizeSignupDiagnostic } from '@/lib/observability/signup-diagnostics'
import { isDebugMode } from '@/lib/utils'

const debugMode = isDebugMode()

posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: '/_ph',
  ui_host: 'https://us.posthog.com',
  defaults: '2025-05-24',

  person_profiles: 'identified_only',
  persistence: 'localStorage+cookie',

  autocapture: false,

  capture_pageview: true,
  capture_pageleave: true,

  capture_heatmaps: true,
  disable_session_recording: debugMode,

  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
    },
  },

  capture_performance: {
    web_vitals_allowed_metrics: ['LCP', 'CLS', 'FCP', 'INP'],
    web_vitals_delayed_flush_ms: 5000,
    __web_vitals_max_value: 900000,
  },

  capture_exceptions: {
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
    capture_console_errors: false,
  },

  before_send: (event) => annotateClientExceptionEvent(sanitizeSignupDiagnostic(event)),

  fetch_options: {
    cache: 'force-cache',
    next_options: {
      revalidate: 60,
      tags: ['posthog'],
    },
  },
})
